import { useRef } from 'react';
import { useFixedPM2HeaderWhileRefIsInView } from '@pm2/react-utils';
import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../../hook.task-breakpoints.js';
import { wrapper } from './_task.sentence.style.js';
import { CircuitFacitContainer } from './circuit/container.facit.js';
import { CircuitInputContainer } from './circuit/container.input.js';
import { CircuitPrintContainer } from './circuit/container.print.js';
import { HorisontalFacitContainer } from './horisontal/container.facit.js';
import { HorisontalInputContainer } from './horisontal/container.input.js';
import { HorisontalPrintContainer } from './horisontal/container.print.js';
import { VerticalFacitContainer } from './vertical/container.facit.js';
import { VerticalInputContainer } from './vertical/container.input.js';
import { VerticalPrintContainer } from './vertical/container.print.js';
import { jsx } from 'react/jsx-runtime';

function SequenceSequenceTask(props) {
  const ref = useRef(null);
  const pageContext = usePageContext();
  const context = useTaskContext();
  const isMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  useFixedPM2HeaderWhileRefIsInView(ref, context === "input");
  const content = (() => {
    switch (props.task.answerType) {
      case "Vertical":
        if (pageContext === "print") {
          return /*#__PURE__*/jsx(VerticalPrintContainer, {
            ...props
          });
        }
        if (context === "input") {
          return /*#__PURE__*/jsx(VerticalInputContainer, {
            ...props
          });
        } else {
          return /*#__PURE__*/jsx(VerticalFacitContainer, {
            ...props
          });
        }
      case "Horizontal":
        if (pageContext === "print") {
          return /*#__PURE__*/jsx(HorisontalPrintContainer, {
            ...props
          });
        }
        if (isMobile) {
          if (context === "input") {
            return /*#__PURE__*/jsx(VerticalInputContainer, {
              ...props
            });
          } else {
            return /*#__PURE__*/jsx(VerticalFacitContainer, {
              ...props
            });
          }
        }
        if (context === "input") {
          return /*#__PURE__*/jsx(HorisontalInputContainer, {
            ...props
          });
        } else {
          return /*#__PURE__*/jsx(HorisontalFacitContainer, {
            ...props
          });
        }
      case "Circuit":
        if (pageContext === "print") {
          return /*#__PURE__*/jsx(CircuitPrintContainer, {
            ...props
          });
        }
        if (context === "input") {
          return /*#__PURE__*/jsx(CircuitInputContainer, {
            ...props
          });
        } else {
          return /*#__PURE__*/jsx(CircuitFacitContainer, {
            ...props
          });
        }
    }
  })();
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: wrapper,
    children: content
  });
}

export { SequenceSequenceTask };
//# sourceMappingURL=_task.sentence.js.map
